import React, { ReactNode } from 'react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { FontSizes, NeutralColors } from '@fluentui/react';
import { Divider, makeStyles } from '@fluentui/react-components';
import { dividerStyles } from '../../app/common/styles/CommonStyleObjects';

interface IInsightCardProps {
  caption: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mainText: any;
  svgComponent?: ReactNode;
  footerLink?: ReactNode;
}

const useStyles = makeStyles({
  innerCard: { padding: '10px', minHeight: '220px' },
  cardBody: { margin: '10px 10px 20px 10px' },
  outterCard: {
    minHeight: '250px',
    width: '430px',
    minWidth: '430px',
    background: NeutralColors.white,
  },
  cardFooter: { padding: '7px 20px 20px 20px' },
  cardHeader: {
    fontSize: FontSizes.size18,
    padding: '0',
    margin: '10px 10px 20px 10px',
  },
});

const InsightCard = ({
  caption,
  mainText,
  svgComponent,
  footerLink,
}: IInsightCardProps): JSX.Element => {
  const styles = dividerStyles();
  const classes = useStyles();
  return (
    <Stack className={`ms-depth-4 ${classes.outterCard}`}>
      <Stack className={classes.innerCard} grow>
        <Stack horizontal horizontalAlign="space-between">
          <StackItem>
            <h2 className={classes.cardHeader}>{caption}</h2>
          </StackItem>
          <StackItem align="end" disableShrink>
            {svgComponent}
          </StackItem>
        </Stack>
        <Stack disableShrink className={classes.cardBody}>
          {mainText}
        </Stack>
      </Stack>
      {footerLink && (
        <Stack verticalAlign="end">
          <Divider className={styles.divider} />
          <div className={classes.cardFooter}>{footerLink}</div>
        </Stack>
      )}
    </Stack>
  );
};

export default InsightCard;
